import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=c98fc07c&scoped=true"
import script from "./IconsList.vue?vue&type=script&lang=js"
export * from "./IconsList.vue?vue&type=script&lang=js"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=c98fc07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98fc07c",
  null
  
)

export default component.exports